import React from 'react';

import cn from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './StatusPills.module.scss';

export const StatusPill = ({
  text,
  status,
  className,
  tooltip,
  prefix,
  large = false,
  small = false,
  capitalize = false,
  onClick = () => {},
}) => {
  const getStatusClass = () => {
    const statusMap = {
      error: styles.error,
      continue: styles.continue,
      neutral: styles.neutral,
      light: styles.light,
      success: styles.success,
      warning: styles.warning,
      completed: styles.success,
      pending: styles.warning,
      canceled: styles.neutral,
      overdue: styles.error,
      candidate: styles.warningLight,
    };

    return cn(styles.root, statusMap[status?.toLowerCase()] || styles.continue, {
      [className]: className,
      [styles.prefixLayout]: prefix,
      [styles.large]: large,
      [styles.small]: small,
    });
  };

  return (
    <>
      {text && (
        <OverlayTrigger
          trigger={tooltip ? ['hover', 'focus'] : 'none'}
          placement="top"
          overlay={<Tooltip>{tooltip}</Tooltip>}>
          <div className={cn(getStatusClass(), { 'u-capitalize': capitalize })} onClick={onClick}>
            {prefix && (
              <span className={cn(styles.prefix, 'secondary-text u-font-weight-600')}>
                {prefix}
              </span>
            )}
            {text}
          </div>
        </OverlayTrigger>
      )}
    </>
  );
};

export default StatusPill;
